import { makeApiRequest } from '../../utils/api-utils';

// Terms & Conditions DTOs aligned with API documentation
export interface TermsAndConditionsDto {
  id: string;
  version: string;
  terms_conditions_text: string;
  is_expired: boolean;
  is_active: boolean;
  created_at: string; // ISO datetime
  updated_at: string; // ISO datetime
}

export interface CreateTermsAndConditionsDto {
  version: string;
  terms_conditions_text: string;
}

// Generic API response shape from makeApiRequest
export interface ApiResponse<T> {
  data?: T;
  status: number;
  error?: string;
}

// Service functions
export const getAllTerms = async (): Promise<ApiResponse<TermsAndConditionsDto[]>> =>
  makeApiRequest('/terms-and-conditions/');

export const createTerms = async (
  data: CreateTermsAndConditionsDto,
): Promise<ApiResponse<TermsAndConditionsDto>> =>
  makeApiRequest('/terms-and-conditions/', {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const getTermsById = async (
  termsId: string,
): Promise<ApiResponse<TermsAndConditionsDto>> =>
  makeApiRequest(`/terms-and-conditions/${termsId}`);

export const getActiveTerms = async (): Promise<ApiResponse<TermsAndConditionsDto>> =>
  makeApiRequest('/terms-and-conditions/active');

export const expireTerms = async (
  termsId: string,
): Promise<ApiResponse<TermsAndConditionsDto>> =>
  makeApiRequest(`/terms-and-conditions/${termsId}/expire`, { method: 'PUT' });

export const activateTerms = async (
  termsId: string,
): Promise<ApiResponse<TermsAndConditionsDto>> =>
  makeApiRequest(`/terms-and-conditions/${termsId}/activate`, { method: 'PUT' });